var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMetro = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98398 4.6246C6.83796 5.03062 5.56805 8.18084 4.16188 11.6249L1.60528 17.8868L0.777205 17.9664C-0.0122931 18.0421 -0.0473596 18.0891 0.0257792 18.9683L0.102425 19.8906H4.23527H8.36811L8.44576 18.9513C8.51714 18.0901 8.4703 18.012 7.88219 18.012C7.49721 18.012 7.24097 17.8707 7.24097 17.6586C7.24097 17.1704 8.27694 14.5048 8.46554 14.5078C8.5497 14.5091 9.34897 15.6926 10.2417 17.1378C11.1346 18.5828 11.9256 19.7653 12 19.7653C12.0744 19.7653 12.8654 18.5828 13.7583 17.1378C14.651 15.6926 15.4578 14.5091 15.5512 14.5078C15.7531 14.5048 16.759 17.1183 16.759 17.6458C16.759 17.8717 16.5136 18.012 16.1178 18.012C15.5297 18.012 15.4829 18.0901 15.5542 18.9513L15.6319 19.8906H19.7647H23.8976L23.9742 18.9683C24.0474 18.0891 24.0123 18.0421 23.2228 17.9664L22.3947 17.8868L19.6395 11.0808C18.1241 7.33749 16.8232 4.21432 16.7485 4.14043C16.6739 4.06654 15.6031 5.74723 14.369 7.87551C13.1349 10.0036 12.0656 11.7461 11.9925 11.7476C11.9196 11.7489 10.9693 10.2004 9.88098 8.30608C7.10847 3.48093 7.30534 3.73115 6.98398 4.6246Z",
    fill: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMetro, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/metro.42564d48.svg";
export { ForwardRef as ReactComponent };